import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import Clients from "@/pages/Clients";
import Doctor from "@/pages/Doctor";
import Academy from "@/pages/Academy";
import Careers from "@/pages/Careers";
import StatusPage from "@/pages/Status";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminPipeline from "@/pages/AdminPipeline";
import AdminFinance from "@/pages/AdminFinance";
import AdminConsultations from "@/pages/AdminConsultations";
import AdminJobs from "@/pages/AdminJobs";
import AuthCallback from "@/pages/AuthCallback";
import MyDashboard from "@/pages/MyDashboard";
import { UserProvider } from "@/lib/userContext";

function AppRoutes() {
    const location = useLocation();
    // CRITICAL: Detect session_id during render (NOT useEffect) to avoid race conditions.
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (location.hash && location.hash.includes("session_id=")) {
        return <AuthCallback />;
    }

    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/doctor" element={<Doctor />} />
            <Route path="/academy" element={<Academy />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/status" element={<StatusPage />} />
            <Route path="/status/:trackingId" element={<StatusPage />} />
            <Route path="/my" element={<MyDashboard />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/clients" element={<AdminPipeline pipeline="client" />} />
            <Route path="/admin/doctor" element={<AdminPipeline pipeline="doctor" />} />
            <Route path="/admin/academy" element={<AdminPipeline pipeline="academy" />} />
            <Route path="/admin/careers" element={<AdminPipeline pipeline="career" />} />
            <Route path="/admin/finance" element={<AdminFinance />} />
            <Route path="/admin/consultations" element={<AdminConsultations />} />
            <Route path="/admin/jobs" element={<AdminJobs />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <UserProvider>
                    <AppRoutes />
                    <Toaster
                        theme="dark"
                        position="bottom-right"
                        toastOptions={{
                            style: {
                                background: "#0a0a0a",
                                border: "1px solid rgba(255,255,255,0.1)",
                                color: "#fff",
                            },
                        }}
                    />
                </UserProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
